var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg029Download(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V13.59L16.29 10.29C16.5437 10.0363 16.9134 9.93728 17.2599 10.0301C17.6064 10.123 17.877 10.3936 17.9699 10.7401C18.0627 11.0866 17.9637 11.4563 17.71 11.71L12.71 16.71C12.5222 16.8993 12.2666 17.0058 12 17.0058C11.7334 17.0058 11.4778 16.8993 11.29 16.71L6.29 11.71C5.89788 11.3179 5.89788 10.6821 6.29 10.29C6.68212 9.89788 7.31788 9.89788 7.71 10.29L11 13.59V3ZM2 20C2 19.4477 2.44772 19 3 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg029Download);
export default __webpack_public_path__ + "static/media/029-download.8778edc8b6de517f66baa4115ab2d81f.svg";
export { ForwardRef as ReactComponent };